import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface WebhookBuilderState {
  endpointKey: string;
  includedFields: Record<string, boolean>;
  fieldValues: Record<string, string>;
  locationId: string;
  baseUrl: string;
}

const initialState: WebhookBuilderState = {
  endpointKey: "",
  includedFields: {},
  fieldValues: {},
  locationId: "",
  baseUrl: "",
};

const webhookBuilderSlice = createSlice({
  name: "webhookBuilder",
  initialState,
  reducers: {
    setWebhookSelection: (state, action: PayloadAction<Partial<WebhookBuilderState>>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setWebhookSelection } = webhookBuilderSlice.actions;
export default webhookBuilderSlice.reducer;